import React from 'react';
import { ModalContent } from '../modal/content.js';
export const SheetContent = (props) => React.createElement(ModalContent, { ...props });
